'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_ListAccountUsersPage(id, name) {
  this.wW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.CW = null;
  this.wW = id;
  this.CW = name;
}
export { $c_Lpresto_ListAccountUsersPage as $c_Lpresto_ListAccountUsersPage };
$p = $c_Lpresto_ListAccountUsersPage.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ListAccountUsersPage;
/** @constructor */
function $h_Lpresto_ListAccountUsersPage() {
}
export { $h_Lpresto_ListAccountUsersPage as $h_Lpresto_ListAccountUsersPage };
$h_Lpresto_ListAccountUsersPage.prototype = $p;
$p.dl = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
});
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_ListAccountUsersPage)) {
    var this$1 = this.wW;
    var b = x$0.wW;
    if (((this$1.e === b.e) && (this$1.f === b.f))) {
      return (this.CW === x$0.CW);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "ListAccountUsersPage";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.wW;
  }
  if ((n === 1)) {
    return this.CW;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_ListAccountUsersPage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iE)));
}
export { $isArrayOf_Lpresto_ListAccountUsersPage as $isArrayOf_Lpresto_ListAccountUsersPage };
var $d_Lpresto_ListAccountUsersPage = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ListAccountUsersPage, "presto.ListAccountUsersPage", ({
  iE: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_ListAccountUsersPage as $d_Lpresto_ListAccountUsersPage };
//# sourceMappingURL=presto.-List-Account-Users-Page.js.map
